import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type FetchPaymentWayOperation = paths['/executor_web/payment_ways/{type}/{id}']['get'];

export type FetchPaymentWayPath = FetchPaymentWayOperation['parameters']['path'];
export type FetchPaymentWayResponse = FetchPaymentWayOperation['responses'][200]['content']['application/json'];

function paymentWayPath(type: string, id: number): string {
	return `payment_ways/${encodeURIComponent(type)}/${id}`;
}

/** GET `/executor_web/payment_ways/{type}/{id}` — данные одного метода оплаты */
export function fetchPaymentWay(path: FetchPaymentWayPath, signal?: AbortSignal) {
	return axiosInstance.get<FetchPaymentWayResponse>(paymentWayPath(path.type, path.id), {signal});
}
